import { useEffect, useState } from "react";
import BlogPostEntity from "../../../../../domain/entities/BlogPostEntity";
import Layout from "../../../layout/Layout";
import "./BlogDetailedPageStyles.scss";
import { useParams, useSearchParams } from "react-router-dom";
import NotResultsComponent from "../../../components/notResults/NotResultsComponent";
import LoadingComponent from "../../../components/LoadingComponent/LoadingComponent";
import DateParse from "../../../../utils/DateParse";
import GetBlogPostByIdUseCase, {
    GetBlogPostByIdUseCaseName,
} from "../../../../../domain/use_cases/blog/GetBlogPostByIdUseCase.tsx";
import di from "../../../../../di/DependencyInjection";
import HostApi from "../../../../../data/settings/HostApi";
import { Carousel1 } from "../../../components/carousel/carousel";
import { Helmet } from "react-helmet-async";
import { API_URL } from "../../../../../config/env";

const BlogDetailedPage = () => {
    const { id } = useParams<{ id: string }>();
    const [blogData, setBlogData] = useState(undefined);
    const [carsBlog, setCarsBlog] = useState(undefined);
    // const [blog, setBlog] = useState<BlogPostEntity | undefined | null>(undefined);
    const [searchParams, setSearchParams] = useSearchParams();

    const _getBlog = async () => {
        try {
            // const response = await di.get<GetBlogPostByIdUseCase>(GetBlogPostByIdUseCaseName).call(id!);
            const response = await HostApi.get(`/post/${searchParams.get("id")}/`);
            // setBlog(response);
            setBlogData(response);
            fetch(`${API_URL}/filter-cars/?page=1`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.parse(response?.post?.json_filter_cars),
            })
                .then((response2) => response2.json())
                .then((data) => {
                    setCarsBlog(data.results);
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        } catch (error) {
            // setBlog(null);
        }
    };

    const getEmbedUrl = (url: string) => {
        if (!url) return "";
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        const videoId = match && match[2].length === 11 ? match[2] : null;
        return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
    };

    useEffect(() => {
        const figureElement = document.querySelector("figure");
        if (figureElement) {
            figureElement.classList.remove("table");
        }

        const tableElements = document.querySelectorAll("table");
        tableElements.forEach((table) => {
            table.classList.add("table");
        });
        console.warn(blogData?.post?.json_filter_cars);
    }, [blogData]);

    useEffect(() => {
        _getBlog();
    }, [id]);

    const VideoPlayer = ({ videoId }) => {
        const [isPlaying, setIsPlaying] = useState(false);

        const handlePlayVideo = () => {
            setIsPlaying(true);
        };

        const videoSrc = videoId;
        return (
            <div className="video-container">
                {
                    <iframe
                        width="100%"
                        height="500"
                        src={videoSrc}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    ></iframe>
                }
            </div>
        );
    };

    const VideoPlayerYoutube = ({ videoUrl }: { videoUrl: string }) => {
        const embedUrl = getEmbedUrl(videoUrl);

        return (
            <div className="video-container my-4">
                <iframe
                    width="100%"
                    height="500"
                    src={embedUrl}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    style={{ borderRadius: "12px" }}
                ></iframe>
            </div>
        );
    };

    return (
        <div className="blog_detailed_page">
            <Helmet>
                <title>
                    {blogData?.post.metaTitle || blogData?.post.title || "Blog WCAR - Artículos sobre autos usados"}
                </title>
                <meta name="description" content={blogData?.post.metaDescription} />
                <meta name="keywords" content={blogData?.post.keywords} />
                <meta name="title" content={blogData?.post.metaTitle} />
            </Helmet>
            <Layout>
                {id === undefined ||
                    (blogData === null && (
                        <div className="py-5">
                            <NotResultsComponent />
                        </div>
                    ))}
                {blogData === undefined && (
                    <div className="py-5">
                        <LoadingComponent />
                    </div>
                )}
                {!blogData && (
                    <h1 style={{ position: "absolute", opacity: 0, pointerEvents: "none" }}>
                        Blog WCAR - Artículos sobre autos usados
                    </h1>
                )}
                {blogData !== null && blogData !== undefined && (
                    <div>
                        <div className="container outstanding_container p-4">
                            <div className="row d-flex justify-content-center">
                                <section className="col-md-10 section_1">
                                    {/* <div className="tag">{blogData?.post?.tagName}</div> */}
                                    <h1 className="my-2 text_bold" style={{ fontSize: "36px" }}>
                                        {blogData?.post?.title}
                                    </h1>
                                    <div className="blog_info_user">
                                        <span className="text_gray date">
                                            {/* {DateParse.dateToMonthDayYear(blogData.createdAt)} */}
                                            {new Intl.DateTimeFormat("es-ES", {
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric",
                                            }).format(new Date(blogData?.post?.created_at))}
                                        </span>
                                    </div>
                                    <img
                                        src={blogData?.post?.photoUrl}
                                        alt={blogData?.post?.title}
                                        title={blogData?.post?.title}
                                        className="img-fluid w-100 object_cover img_card_blog my-4"
                                        style={{
                                            minHeight: "260px",
                                            maxHeight: "462px",
                                            objectFit: "cover",
                                            borderRadius: "12px",
                                        }}
                                    />
                                </section>
                                <section className="col-md-10 mt-5 section_2 section-content">
                                    {blogData?.paragraphs
                                        ?.sort((a: any, b: any) => a.order - b.order)
                                        .map((paragraph: any, index: number) => {
                                            const oembedRegex = /url="([^"]+)"/;
                                            const match = paragraph.content?.match(oembedRegex);
                                            const youtubeUrl = match ? match[1] : null;

                                            return (
                                                <>
                                                    {paragraph.title_paragraph && paragraph.title_h3 ? (
                                                        <h3 style={{ marginBottom: 16 }}>
                                                            {paragraph.title_paragraph}
                                                        </h3>
                                                    ) : (
                                                        <h2 style={{ marginBottom: 16 }}>
                                                            {paragraph.title_paragraph}
                                                        </h2>
                                                    )}

                                                    {/* <video controls autoPlay src={paragraph.file}></video> */}
                                                    {paragraph?.video_url && (
                                                        <>
                                                            <VideoPlayer videoId={paragraph?.video_url} />
                                                        </>
                                                    )}
                                                    {youtubeUrl && <VideoPlayerYoutube videoUrl={youtubeUrl} />}
                                                    {paragraph?.file && (
                                                        <>
                                                            {paragraph?.type_file ? (
                                                                <video
                                                                    controls
                                                                    src={paragraph.file}
                                                                    style={{
                                                                        width: "100%",
                                                                        minHeight: "260px",
                                                                        maxHeight: "462px",
                                                                        borderRadius: "12px",
                                                                    }}
                                                                ></video>
                                                            ) : (
                                                                <img
                                                                    src={paragraph.file}
                                                                    alt={paragraph?.title}
                                                                    title={paragraph?.title}
                                                                    className="img-fluid w-100 object_cover img_card_blog my-4"
                                                                    style={{
                                                                        minHeight: "260px",
                                                                        maxHeight: "462px",
                                                                        objectFit: "cover",
                                                                        borderRadius: "12px",
                                                                    }}
                                                                />
                                                            )}
                                                        </>
                                                    )}

                                                    <p
                                                        key={index}
                                                        dangerouslySetInnerHTML={{ __html: paragraph.content ?? "" }}
                                                    ></p>
                                                    <br />
                                                </>
                                            );
                                        })}
                                </section>
                            </div>
                        </div>
                    </div>
                )}

                {carsBlog?.length !== 0 && (
                    <section className="container mb-5 mt-4">
                        <p className="mb-4 ms-4 text-black fs-2 text fw-normal">Vehículos en venta</p>
                        <Carousel1 cars={!carsBlog ? [] : carsBlog} />
                    </section>
                )}
            </Layout>
        </div>
    );
};

export default BlogDetailedPage;
